import 'twin.macro';

import React from 'react';
import { useContext } from 'react';
import { useState } from 'react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { deposit_available_for, invest_available_for, is_prepaid_card_open } from '@/app/availlability_vars';
import { getChannel } from '@/app/store/slices/channel';
import DepositCard from '@/assets/images/deposit-card-img.svg';
import InvestCard from '@/assets/images/invest_card.webp';
import PrepaidCard from '@/assets/images/prepaid-card-img.webp';
import CardBox from '@/components/card-box/card-box';
import { DeviceInfoContext } from '@/contexts/device-info-context';

import DepositBenefitsContainer from '../deposite-benefits-container';

function LandingCardTypes() {
  const channel = useSelector(getChannel);

  const [activeTab, setActiveTab] = useState(deposit_available_for?.find(item => item === channel) ? 1 : 2);
  const { isMobile } = useContext(DeviceInfoContext);
  const { t } = useTranslation();

  console.log(
    'invest_available_for?.find(item => item === channel)',
    invest_available_for?.find(item => item === channel)
  );

  const Cards = useMemo(
    () => [
      {
        Image: DepositCard,
        title: t('info_landing.card_types.deposit.title'),
        isSoon: !deposit_available_for?.find(item => item === channel),
        caption: (
          <span>
            {' '}
            {t('info_landing.card_types.deposit.subtitle')} <br />
            {t('info_landing.card_types.deposit.subtitle2')}
          </span>
        )
      },
      {
        Image: InvestCard,
        title: t('info_landing.card_types.invest.title'),
        isSoon: !invest_available_for?.find(item => item === channel),
        caption: (
          <span>
            {t('info_landing.card_types.invest.subtitle')} <br />
            {t('info_landing.card_types.invest.subtitle2')} <br />
          </span>
        )
      },
      {
        Image: PrepaidCard,
        title: t('info_landing.card_types.prepaid.title'),
        isSoon: !is_prepaid_card_open || channel === 'UZBEKISTAN',
        caption: t('info_landing.card_types.prepaid.subtitle')
      }
    ],
    [channel]
  );

  return (
    <div tw=' flex flex-col items-center relative'>
      <div tw='block sm:flex w-full justify-between h-full'>
        {Cards.map((card, index) => (
          <CardBox
            key={card.Image}
            Image={card.Image}
            caption={card.caption}
            isActive={card.isActive}
            isSoon={card.isSoon}
            title={card.title}
            index={index}
            setActiveTab={setActiveTab}
            activeTab={activeTab}
          />
        ))}
      </div>
      {!isMobile && <DepositBenefitsContainer activeTab={activeTab} />}
    </div>
  );
}

export default LandingCardTypes;
